// extracted by mini-css-extract-plugin
module.exports = {"bp-phone":"321px","bp-phone-l":"375px","bp-phone-xl":"480px","bp-phone-xxl":"540px","bp-tablet":"768px","bp-desktop":"928px","bp-max":"944px"};